import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { PosturalModel } from '../models/postural.model';
import { Estate } from '../utils/enum.util';

@Injectable()

export class PosturalService {

    list: any;
    current: any;

    private antiRebound = 300;
    private timestamp   = 0;
    private antiReboundField: string;

    constructor(public apiService: ApiService) {
        this.reset();
    }

    reset() {
        this.list    = [];
        this.current = null;
    }

    getAll(privateId) {
        this.reset();

        this.apiService.get('client/' + privateId + '/posturals', '').subscribe(res=> {
            res.data.forEach((e)=> {
                this.list.push(PosturalModel.j2o(e, this));
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    del() {
        let tmp = this.current;
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i] == this.current) {
                this.list.splice(i, 1);
            }
        }
        this.current = null;
        if (tmp.id) {
            this.apiService.delete('postural/' + tmp.id, null).subscribe(_res=> {

            }, (_err)=> {
                this.apiService.error(_err);
            });
        }
    }

    post() {
        let tmp        = {
            title: this.current.title
        }
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.post('client/' + this.current.clientPrivateId + '/postural', tmp).subscribe(res=> {
                    this.current.id             = res.data.id;
                    this.current.created        = new Date();
                    this.current.state.title    = Estate.Save;
                    this.current.state.measure1 = Estate.Save;
                    this.current.state.measure2 = Estate.Save;
                    this.current.state.measure3 = Estate.Save;
                    this.current.state.measure4 = Estate.Save;
                    this.current.state.measure5 = Estate.Save;
                    this.current.state.measure6 = Estate.Save;
                    this.current.state.measure7 = Estate.Save;
                    this.current.state.measure8 = Estate.Save;
                    this.current.state.measure9 = Estate.Save;
                    this.current.state.measure10 = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                });
            }
        }, this.antiRebound);
    }

    addNew(privateId) {
        let tmp             = new PosturalModel(this);
        tmp.clientPrivateId = privateId;
        tmp.title           = '';
        this.current        = tmp;
        this.list.push(tmp);
    }

    put(postural: PosturalModel, field: string) {
        let data = {};

        postural.state[field] = Estate.Saving;

        data = {[field]: postural[field]};

        //antiRebounce
        this.antiReboundField = field;
        this.timestamp        = new Date().getTime();
        setTimeout(()=> {
            if (this.antiReboundField != field || this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('postural/' + postural.id, data).subscribe((_res)=> {
                    postural.state[field] = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                    postural.state[field] = Estate.Error;
                });
            }
        }, this.antiRebound);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/postural.service.ts